module.exports = __webpack_public_path__ + "static/img/dfgj.d415032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dfgj.png
// module id = EJNz
// module chunks = 0